import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ItemCard as Block } from "./ItemCardBlock";
import { defaultData } from "./ItemCardDefaultData";
import imagePreview from "./item_card_preview.png";

export const ItemCardBlock: BlockExport = {
  type: "component",
  Block,
  imagePreview: {
    type: "image-url",
    lg: imagePreview,
  },
  defaultData,
  meta: {
    name: "Item Card",
    version: 1,
    nameI18n: "builder_ui.block_type.item_card",
    isHidden: true,
    props: {
      image: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      header: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
      description: {
        name: "Description",
        nameI18n: "builder_ui.prop_type.description",
        prop: "children",
        type: "children",
        accepts: ["Basic", "Media", "Text", "Actions", "Layout"],
      },
    },
  },
};
